import {
    ProductDetail,
  } from '.';
  import {
    HomeLayout
  } from '../layout';
  export default {
    path: '/product',
    name: 'Product',
    component: HomeLayout,
    childRoutes: [
      { path: 'detail/:id', name: 'ProductDetail', component: ProductDetail },
    //   { path: 'counter', name: 'Counter page', component: CounterPage },
    //   { path: 'reddit', name: 'Reddit list page', component: RedditListPage },
    ],
  };
  


// WEBPACK FOOTER //
// ./src/features/product/route.js